import { render, staticRenderFns } from "./ReceiptAddNew.vue?vue&type=template&id=222559ac&"
import script from "./ReceiptAddNew.vue?vue&type=script&lang=js&"
export * from "./ReceiptAddNew.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptAddNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports